import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProjectStore } from '@ffx/app-store';

export const projectSettingsDataResolver: ResolveFn<boolean> = async (route, state) => {
    const projectStore = inject(ProjectStore);
    const projectId = state.url.split('/')[1];
    try {
        await projectStore.getProjectSettings(projectId);
        return true;
    } catch {
        return false;
    }
};
